import { useState } from "react";
export default function useSwipe(input) {
    var _a = useState({ x: 0, y: 0 }), touchStart = _a[0], setTouchStart = _a[1];
    var _b = useState({ x: 0, y: 0 }), touchEnd = _b[0], setTouchEnd = _b[1];
    var minSwipeDistance = 50;
    var onTouchStart = function (e) {
        setTouchEnd({ x: 0, y: 0 }); // Reset end coordinates
        setTouchStart({
            x: e.targetTouches[0].clientX,
            y: e.targetTouches[0].clientY
        });
    };
    var onTouchMove = function (e) {
        setTouchEnd({
            x: e.targetTouches[0].clientX,
            y: e.targetTouches[0].clientY
        });
    };
    var onTouchEnd = function () {
        if (!touchStart.x || !touchEnd.x)
            return;
        var horizontalDistance = touchStart.x - touchEnd.x;
        var verticalDistance = touchStart.y - touchEnd.y;
        // Check if the swipe is more horizontal or vertical
        if (Math.abs(horizontalDistance) > Math.abs(verticalDistance)) {
            // Horizontal swipe
            var isLeftSwipe = horizontalDistance > minSwipeDistance;
            var isRightSwipe = horizontalDistance < -minSwipeDistance;
            if (isLeftSwipe && input.onSwipedLeft) {
                input.onSwipedLeft();
            }
            if (isRightSwipe && input.onSwipedRight) {
                input.onSwipedRight();
            }
        }
        else {
            // Vertical swipe
            var isUpSwipe = verticalDistance > minSwipeDistance;
            var isDownSwipe = verticalDistance < -minSwipeDistance;
            if (isUpSwipe && input.onSwipedUp) {
                input.onSwipedUp();
            }
            if (isDownSwipe && input.onSwipedDown) {
                input.onSwipedDown();
            }
        }
    };
    return {
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd
    };
}
